/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff, FiMail, FiLock, FiCheck } from 'react-icons/fi';
import AppButton from '../../shared/components/app-button/AppButton';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import { doLoginApi, getAppConstants } from '../../api/loginApi';
import {
  setStringInLs,
  setDataInLS,
  getStringFromLS,
} from '../../shared/helper-utils/localStorage';
import {
  APP_LOGGEDIN_AGENTID,
  NAVIGATION_ROUTES,
} from '../../shared/constants/Constants';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import AppModal from '../../shared/components/app-modal/AppModal';
import {
  APP_CONFIG,
  APP_USER_AUTH,
  APP_USER_PROFILE,
  APP_LOGO_URL,
  APP_AGENT_LOGO_URL,
} from '../../saas/AppStorageStaticNames';
import { useAppContext } from '../../saas/AppConfigWrapper';
import './loginFastays.scss';
import ForgotPassword from '../login/ForgotPassword';
import { isNullOrEmpty } from '../../shared/helper-utils/appUtils';

export default function LoginFastays() {
  const { appConfig } = useAppContext();
  const navigate = useNavigate();

  // Login states
  const [showForm, setShowForm] = useState('login');
  const [alert, setAlert] = useState(undefined);
  const [validationError, setValidationError] = useState(false);
  const [login, setLogin] = useState({
    agent_userid: '',
    agent_password: '',
    opid: 'AU001',
    usertype: 'reactclient',
    agencycode: '',
    responseformat: 'JSON',
    securetoken: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Field focus states
  const [userFocused, setUserFocused] = useState(false);
  const [passFocused, setPassFocused] = useState(false);

  // UI state
  const [imageLoadError, setImageLoadError] = useState(false);
  const [hasNoImage, setHasNoImage] = useState(false);

  // Load external assets (fonts & icons) dynamically on mount
  useEffect(() => {
    // Tabler Icons CDN
    const linkId = 'tabler-icons-cdn';
    if (!document.getElementById(linkId)) {
      const link = document.createElement('link');
      link.id = linkId;
      link.rel = 'stylesheet';
      link.href =
        'https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@3.3.0/tabler-icons.min.css';
      document.head.appendChild(link);
    }
    // Inter Google Fonts
    const fontId = 'google-font-inter';
    if (!document.getElementById(fontId)) {
      const link = document.createElement('link');
      link.id = fontId;
      link.rel = 'stylesheet';
      link.href =
        'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  // Secure token generation using FingerprintJS
  const getSecureToken = async () => {
    setIsLoading(true);
    try {
      if (typeof FingerprintJS !== 'undefined') {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        setLogin((prev) => ({ ...prev, securetoken: result.visitorId }));
      }
    } catch (error) {
      setLogin((prev) => ({ ...prev, securetoken: '' }));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getSecureToken();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setLogin((prev) => ({ ...prev, [name]: value }));
  };

  const handleLoginSubmit = async (event) => {
    event.preventDefault();
    if (!login.agent_userid || !login.agent_password) {
      setValidationError(true);
      return;
    }
    setValidationError(false);
    setIsLoading(true);
    const loginResponse = await doLoginApi(login);
    setIsLoading(false);

    if (loginResponse?.ApiStatus?.StatusCode !== 200) {
      setAlert({
        variant: 'error',
        title: 'Login Failed',
        description: loginResponse?.ApiStatus?.Message,
      });
    } else {
      const { Result } = loginResponse.ApiStatus;
      if (Result === 'OTPSENT') {
        setShowOtpModal(true);
      } else {
        const profileInfo = Result.split('@@@');
        const profile = {
          agentId: profileInfo[0],
          profileId: profileInfo[1],
          title: profileInfo[2],
          firstName: profileInfo[3],
          lastName: profileInfo[4],
          systemRoleId: profileInfo[5],
          companyName: profileInfo[6],
        };
        setDataInLS(APP_USER_PROFILE, profile);
        setStringInLs(APP_LOGGEDIN_AGENTID, profile.agentId);
        setStringInLs(APP_USER_AUTH, loginResponse.ApiStatus.TransactionStatus);

        setIsLoading(true);
        const response = await getAppConstants();
        if (response?.Root?.Status === 'OK') {
          const { ConfigSetting } = response.Root.Result.ConfigSettings;
          setDataInLS(APP_CONFIG, ConfigSetting);
        }
        setIsLoading(false);
        window.location.href = NAVIGATION_ROUTES.LANDING;
      }
    }
  };

  const handleShowForm = (formType) => {
    setShowForm(formType);
  };

  const handleSignUpClick = () => {
    navigate(NAVIGATION_ROUTES.AGENT_REGISTRATION);
  };

  return (
    <div className="fl-page">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => setAlert(undefined)}
        />
      )}

      {/* ═══ HEADER ═══ */}
      <header
        className="header"
        style={{
          position: 'relative',
          zIndex: 200,
          background: '#ffffff',
          borderBottom: '1px solid var(--border)',
        }}
      >
        <div className="container header-inner">
          <NavLink to="/" className="cursor-pointer app-header-logo">
            {!imageLoadError &&
            !isNullOrEmpty(getStringFromLS(APP_AGENT_LOGO_URL)) ? (
              <img
                src={getStringFromLS(APP_AGENT_LOGO_URL)}
                alt=""
                style={{ maxHeight: `${appConfig.logoHeight}px` }}
                onError={(e) => {
                  e.target.src = null;
                  e.currentTarget.onerror = null;
                  setImageLoadError(true);
                }}
              />
            ) : !hasNoImage ? (
              <img
                src={getStringFromLS(APP_LOGO_URL)}
                alt=""
                style={{ maxHeight: `${appConfig.logoHeight}px` }}
                onError={(e) => {
                  e.target.src = null;
                  e.currentTarget.onerror = null;
                  setHasNoImage(true);
                }}
              />
            ) : (
              ''
            )}
          </NavLink>
          <nav className="header-nav">
            <a href="/b2b-portal-for-travel-agents">Agents</a>
            <a href="/testimonials">Testimonials</a>
            <a href="/contact-us">Contact Us</a>
          </nav>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <button
              type="button"
              className="header-cta"
              onClick={handleSignUpClick}
            >
              Sign Up
            </button>
          </div>
        </div>
      </header>

      {/* ═══ HERO SECTION WITH LOGIN FORM ═══ */}
      <section
        className="fl-hero-section"
        style={{
          position: 'relative',
          marginTop: 0,
          backgroundImage: "url('/images/fastays/login-bg.png')",
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top center',
          backgroundSize: '100% 100%',
        }}
      >
        <div className="container fl-hero-inner">
          <div className="fl-hero-right">
            <div className="fl-login-card">
              {showForm === 'login' ? (
                <>
                  <h2 className="fl-login-title">Agent Portal</h2>
                  <p className="fl-login-subtitle">
                    Sign in to your dashboard to start booking
                  </p>

                  <form
                    onSubmit={handleLoginSubmit}
                    className="d-flex flex-column"
                  >
                    <div className="fl-form-field">
                      <span className="fl-field-label">User ID</span>
                      <div
                        className={`fl-input-container${
                          userFocused ? ' fl-focused' : ''
                        }${
                          validationError && !login.agent_userid
                            ? ' fl-error'
                            : ''
                        }`}
                      >
                        <span className="fl-input-icon">
                          <FiMail size={18} />
                        </span>
                        <input
                          type="text"
                          name="agent_userid"
                          className="fl-input"
                          placeholder="Enter user ID or email"
                          onFocus={() => setUserFocused(true)}
                          onBlur={() => setUserFocused(false)}
                          onChange={handleChange}
                          value={login.agent_userid}
                          autoComplete="username"
                        />
                      </div>
                      {validationError && !login.agent_userid && (
                        <span className="fl-error-msg">
                          User ID is required
                        </span>
                      )}
                    </div>

                    <div className="fl-form-field">
                      <span className="fl-field-label">Password</span>
                      <div
                        className={`fl-input-container${
                          passFocused ? ' fl-focused' : ''
                        }${
                          validationError && !login.agent_password
                            ? ' fl-error'
                            : ''
                        }`}
                      >
                        <span className="fl-input-icon">
                          <FiLock size={18} />
                        </span>
                        <input
                          type={showPassword ? 'text' : 'password'}
                          name="agent_password"
                          className="fl-input fl-input-with-eye"
                          placeholder="••••••••"
                          onFocus={() => setPassFocused(true)}
                          onBlur={() => setPassFocused(false)}
                          onChange={handleChange}
                          value={login.agent_password}
                          autoComplete="current-password"
                        />
                        <button
                          type="button"
                          className="fl-eye-btn"
                          onClick={() => setShowPassword((prev) => !prev)}
                        >
                          {showPassword ? (
                            <FiEye size={18} />
                          ) : (
                            <FiEyeOff size={18} />
                          )}
                        </button>
                      </div>
                      {validationError && !login.agent_password && (
                        <span className="fl-error-msg">
                          Password is required
                        </span>
                      )}
                    </div>

                    <button
                      type="button"
                      className="fl-forgot-link"
                      onClick={() => handleShowForm('forgot')}
                    >
                      Forgot Password?
                    </button>

                    <button type="submit" className="fl-btn-submit">
                      Login
                    </button>

                    <div className="fl-signup-prompt">
                      Don&apos;t have an account?
                      <button
                        type="button"
                        className="fl-link"
                        onClick={handleSignUpClick}
                      >
                        Sign Up
                      </button>
                    </div>
                  </form>
                </>
              ) : (
                <ForgotPassword
                  onShowForm={handleShowForm}
                  onLoading={setIsLoading}
                  onAlert={setAlert}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ═══ SERVICES ═══ */}
      <section className="section" id="services">
        <div className="container">
          <div className="section-header">
            <div>
              <span className="section-label">What we offer</span>
              <h2 className="section-title">
                All Services in <span>One Dashboard</span>
              </h2>
            </div>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <img
                className="service-card-img"
                src="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=400&q=80"
                alt="Book flights"
                loading="lazy"
              />
              <div className="service-card-body">
                <div className="svc-name">
                  <i className="ti ti-plane" aria-hidden="true" />
                  Flights
                </div>
                <div className="svc-desc">500+ airlines. Best agent fares.</div>
              </div>
            </div>
            <div className="service-card">
              <img
                className="service-card-img"
                src="https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&q=80"
                alt="Book hotels"
                loading="lazy"
              />
              <div className="service-card-body">
                <div className="svc-name">
                  <i className="ti ti-building" aria-hidden="true" />
                  Stays
                </div>
                <div className="svc-desc">1M+ hotels worldwide.</div>
              </div>
            </div>
            <div className="service-card">
              <img
                className="service-card-img"
                src="https://images.unsplash.com/photo-1570125909232-eb263c188f7e?w=400&q=80"
                alt="Book buses"
                loading="lazy"
              />
              <div className="service-card-body">
                <div className="svc-name">
                  <i className="ti ti-bus" aria-hidden="true" />
                  Buses
                </div>
                <div className="svc-desc">5000+ routes across India.</div>
              </div>
            </div>
            <div className="service-card">
              <img
                className="service-card-img"
                src="https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=400&q=80"
                alt="Trip protection plans"
                loading="lazy"
              />
              <div className="service-card-body">
                <div className="svc-name">
                  <i className="ti ti-shield-check" aria-hidden="true" />
                  Trip Protection
                </div>
                <div className="svc-desc">
                  Plans from ₹49. Flights &amp; hotels covered.
                </div>
              </div>
            </div>
            <div className="service-card">
              <img
                className="service-card-img"
                src="https://images.unsplash.com/photo-1503220317375-aaad61436b1b?w=400&q=80"
                alt="Visa assistance"
                loading="lazy"
              />
              <div className="service-card-body">
                <div className="svc-name">
                  <i className="ti ti-world" aria-hidden="true" />
                  Visa
                </div>
                <div className="svc-desc">150+ countries covered.</div>
              </div>
            </div>
            <div className="service-card">
              <img
                className="service-card-img"
                src="https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=400&q=80"
                alt="eSIM global data"
                loading="lazy"
              />
              <div className="service-card-body">
                <div className="svc-name">
                  <i className="ti ti-sim-card" aria-hidden="true" />
                  eSIM
                </div>
                <div className="svc-desc">190+ countries, no roaming.</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ HOW TO REGISTER — STEP SLIDER ═══ */}
      <section className="section section-alt" id="register-process">
        <div className="container">
          <div className="section-header section-header-center">
            <div>
              <span className="section-label">Getting started</span>
              <h2 className="section-title">
                How To <span>Register With Us?</span>
              </h2>
              <p
                style={{
                  fontSize: '13px',
                  color: 'var(--muted)',
                  marginTop: '8px',
                }}
              >
                From sign-up to your first booking in under 5 minutes
              </p>
            </div>
          </div>

          <div style={{ position: 'relative', padding: '0 10px' }}>
            <div className="step-grid">
              <div className="step-card" onClick={handleSignUpClick}>
                <div className="step-num-wrap">
                  <div className="step-number">1</div>
                </div>
                <div className="step-body">
                  <i className="ti ti-user-plus step-icon" />
                  <div className="step-title">Click Register</div>
                  <div className="step-desc">
                    Hit &quot;Register With Us&quot; on the homepage to begin
                    your agent sign-up.
                  </div>
                </div>
              </div>

              <div className="step-card" onClick={handleSignUpClick}>
                <div className="step-num-wrap">
                  <div className="step-number">2</div>
                </div>
                <div className="step-body">
                  <i className="ti ti-forms step-icon" />
                  <div className="step-title">Fill Your Details</div>
                  <div className="step-desc">
                    Enter your business name, contact info, and basic agency
                    details.
                  </div>
                </div>
              </div>

              <div className="step-card" onClick={handleSignUpClick}>
                <div className="step-num-wrap">
                  <div className="step-number">3</div>
                </div>
                <div className="step-body">
                  <i className="ti ti-lock step-icon" />
                  <div className="step-title">Set Username &amp; Password</div>
                  <div className="step-desc">
                    Create your secure login credentials to access your agent
                    dashboard.
                  </div>
                </div>
              </div>

              <div className="step-card step-card-active">
                <div className="step-num-wrap">
                  <div className="step-number-check">
                    <FiCheck size={24} />
                  </div>
                </div>
                <div className="step-body">
                  <i className="ti ti-rocket step-icon" />
                  <div className="step-title" style={{ color: '#fff' }}>
                    You&apos;re All Set!
                  </div>
                  <div
                    className="step-desc"
                    style={{ color: 'rgba(255,255,255,.55)' }}
                  >
                    You&apos;re already registered with us — start booking and
                    earning right away.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ FLIGHT DEALS ═══ */}
      <section className="section" id="flights">
        <div className="container">
          <div className="section-header">
            <div>
              <span className="section-label">Best fares today</span>
              <h2 className="section-title">
                Top Flight <span>Deals</span>
              </h2>
            </div>
          </div>
          <div className="deals-grid">
            <article className="deal-card">
              <div className="deal-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=600&q=80"
                  alt="Goa beach"
                  loading="lazy"
                />
                <div className="deal-img-overlay" />
                <div className="deal-city-info">
                  <div className="deal-from">Delhi →</div>
                  <div className="deal-city">Goa</div>
                </div>
              </div>
              <div className="deal-body">
                <div className="deal-route">
                  <i className="ti ti-plane" aria-hidden="true" /> DEL → GOA ·
                  Non-stop
                </div>
                <div className="deal-price">
                  ₹3,499 <span>/ person</span>
                </div>
                <div className="deal-meta">
                  <span className="deal-badge">🔥 26% off</span>
                  <span className="deal-book">
                    Book now <i className="ti ti-arrow-right" />
                  </span>
                </div>
              </div>
            </article>
            <article className="deal-card">
              <div className="deal-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1529253355930-ddbe423a2ac7?w=600&q=80"
                  alt="Mumbai skyline"
                  loading="lazy"
                />
                <div className="deal-img-overlay" />
                <div className="deal-city-info">
                  <div className="deal-from">Delhi →</div>
                  <div className="deal-city">Mumbai</div>
                </div>
              </div>
              <div className="deal-body">
                <div className="deal-route">
                  <i className="ti ti-plane" aria-hidden="true" /> DEL → BOM ·
                  Non-stop
                </div>
                <div className="deal-price">
                  ₹2,799 <span>/ person</span>
                </div>
                <div className="deal-meta">
                  <span className="deal-badge">⚡ Flash sale</span>
                  <span className="deal-book">
                    Book now <i className="ti ti-arrow-right" />
                  </span>
                </div>
              </div>
            </article>
            <article className="deal-card">
              <div className="deal-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1580584126903-c17d41830450?w=600&q=80"
                  alt="Hyderabad city lights"
                  loading="lazy"
                />
                <div className="deal-img-overlay" />
                <div className="deal-city-info">
                  <div className="deal-from">Bangalore →</div>
                  <div className="deal-city">Hyderabad</div>
                </div>
              </div>
              <div className="deal-body">
                <div className="deal-route">
                  <i className="ti ti-plane" aria-hidden="true" /> BLR → HYD ·
                  Non-stop
                </div>
                <div className="deal-price">
                  ₹1,899 <span>/ person</span>
                </div>
                <div className="deal-meta">
                  <span className="deal-badge">✅ Best price</span>
                  <span className="deal-book">
                    Book now <i className="ti ti-arrow-right" />
                  </span>
                </div>
              </div>
            </article>
            <article className="deal-card">
              <div className="deal-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&q=80"
                  alt="Dubai skyline"
                  loading="lazy"
                />
                <div className="deal-img-overlay" />
                <div className="deal-city-info">
                  <div className="deal-from">Mumbai →</div>
                  <div className="deal-city">Dubai</div>
                </div>
              </div>
              <div className="deal-body">
                <div className="deal-route">
                  <i className="ti ti-plane" aria-hidden="true" /> BOM → DXB ·
                  Non-stop
                </div>
                <div className="deal-price">
                  ₹12,999 <span>/ person</span>
                </div>
                <div className="deal-meta">
                  <span className="deal-badge">🌍 Intl deal</span>
                  <span className="deal-book">
                    Book now <i className="ti ti-arrow-right" />
                  </span>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* ═══ STAYS ═══ */}
      <section className="section" id="stays">
        <div className="container">
          <div className="section-header">
            <div>
              <span className="section-label">Handpicked stays</span>
              <h2 className="section-title">
                Popular <span>Hotels &amp; Resorts</span>
              </h2>
            </div>
          </div>
          <div className="stays-grid">
            <article className="stay-card">
              <div className="stay-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=600&q=80"
                  alt="Marriott Resort Goa"
                  loading="lazy"
                />
                <div className="stay-img-badge">Resort</div>
                <div className="stay-discount">15% OFF</div>
              </div>
              <div className="stay-body">
                <div className="stay-name">Marriott Resort Goa</div>
                <div className="stay-loc">
                  <i className="ti ti-map-pin" aria-hidden="true" /> Panaji, Goa
                </div>
                <div className="stay-footer">
                  <div className="stay-stars" aria-label="5 stars">
                    ★★★★★
                  </div>
                  <div className="stay-price">
                    ₹6,999 <span>/ night</span>
                  </div>
                </div>
              </div>
            </article>
            <article className="stay-card">
              <div className="stay-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=600&q=80"
                  alt="Maldives resort overwater"
                  loading="lazy"
                />
                <div className="stay-img-badge">Beach</div>
                <div className="stay-discount">20% OFF</div>
              </div>
              <div className="stay-body">
                <div className="stay-name">Taj Coral Reef Maldives</div>
                <div className="stay-loc">
                  <i className="ti ti-map-pin" aria-hidden="true" /> North Malé
                  Atoll
                </div>
                <div className="stay-footer">
                  <div className="stay-stars" aria-label="5 stars">
                    ★★★★★
                  </div>
                  <div className="stay-price">
                    ₹24,999 <span>/ night</span>
                  </div>
                </div>
              </div>
            </article>
            <article className="stay-card">
              <div className="stay-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1544550285-f813152fb2fd?w=600&q=80"
                  alt="Himalayan mountain hotel"
                  loading="lazy"
                />
                <div className="stay-img-badge">Mountain</div>
                <div className="stay-discount">10% OFF</div>
              </div>
              <div className="stay-body">
                <div className="stay-name">The Himalayan, Manali</div>
                <div className="stay-loc">
                  <i className="ti ti-map-pin" aria-hidden="true" /> Manali,
                  Himachal
                </div>
                <div className="stay-footer">
                  <div className="stay-stars" aria-label="4 stars">
                    ★★★★☆
                  </div>
                  <div className="stay-price">
                    ₹4,499 <span>/ night</span>
                  </div>
                </div>
              </div>
            </article>
            <article className="stay-card">
              <div className="stay-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1599661046289-e31897846e41?w=600&q=80"
                  alt="Leela Palace Udaipur"
                  loading="lazy"
                />
                <div className="stay-img-badge">Heritage</div>
                <div className="stay-discount">12% OFF</div>
              </div>
              <div className="stay-body">
                <div className="stay-name">The Leela Palace Udaipur</div>
                <div className="stay-loc">
                  <i className="ti ti-map-pin" aria-hidden="true" /> Udaipur,
                  Rajasthan
                </div>
                <div className="stay-footer">
                  <div className="stay-stars" aria-label="5 stars">
                    ★★★★★
                  </div>
                  <div className="stay-price">
                    ₹18,999 <span>/ night</span>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* ═══ BUS ROUTES ═══ */}
      <section className="section section-alt" id="buses">
        <div className="container">
          <div className="section-header">
            <div>
              <span className="section-label">Top routes</span>
              <h2 className="section-title">
                Popular <span>Bus Routes</span>
              </h2>
            </div>
          </div>
          <div className="bus-grid">
            <article className="bus-card">
              <div className="bus-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1477587458883-47145ed94245?w=500&q=80"
                  alt="Jaipur Hawa Mahal"
                  loading="lazy"
                />
                <div className="bus-img-overlay" />
                <div className="bus-img-label">Delhi → Jaipur</div>
              </div>
              <div className="bus-body">
                <div className="bus-meta">6h · AC Sleeper · 28 operators</div>
                <div className="bus-price">from ₹499</div>
                <span className="bus-badge">
                  <i className="ti ti-clock" aria-hidden="true" /> 6 hrs
                </span>
              </div>
            </article>
            <article className="bus-card">
              <div className="bus-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=500&q=80"
                  alt="Pune city"
                  loading="lazy"
                />
                <div className="bus-img-overlay" />
                <div className="bus-img-label">Mumbai → Pune</div>
              </div>
              <div className="bus-body">
                <div className="bus-meta">3.5h · AC Volvo · 42 operators</div>
                <div className="bus-price">from ₹299</div>
                <span className="bus-badge">
                  <i className="ti ti-clock" aria-hidden="true" /> 3.5 hrs
                </span>
              </div>
            </article>
            <article className="bus-card">
              <div className="bus-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=500&q=80"
                  alt="Chennai Marina Beach"
                  loading="lazy"
                />
                <div className="bus-img-overlay" />
                <div className="bus-img-label">Bangalore → Chennai</div>
              </div>
              <div className="bus-body">
                <div className="bus-meta">6h · AC Volvo · 35 operators</div>
                <div className="bus-price">from ₹649</div>
                <span className="bus-badge">
                  <i className="ti ti-clock" aria-hidden="true" /> 6 hrs
                </span>
              </div>
            </article>
            <article className="bus-card">
              <div className="bus-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1605649487212-47bdab064df7?w=500&q=80"
                  alt="Bangalore city"
                  loading="lazy"
                />
                <div className="bus-img-overlay" />
                <div className="bus-img-label">Hyderabad → Bangalore</div>
              </div>
              <div className="bus-body">
                <div className="bus-meta">8h · Sleeper · 20 operators</div>
                <div className="bus-price">from ₹799</div>
                <span className="bus-badge">
                  <i className="ti ti-clock" aria-hidden="true" /> 8 hrs
                </span>
              </div>
            </article>
            <article className="bus-card">
              <div className="bus-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1548013146-72479768bada?w=500&q=80"
                  alt="Agra Taj Mahal"
                  loading="lazy"
                />
                <div className="bus-img-overlay" />
                <div className="bus-img-label">Delhi → Agra</div>
              </div>
              <div className="bus-body">
                <div className="bus-meta">4h · AC Seater · 15 operators</div>
                <div className="bus-price">from ₹349</div>
                <span className="bus-badge">
                  <i className="ti ti-clock" aria-hidden="true" /> 4 hrs
                </span>
              </div>
            </article>
            <article className="bus-card">
              <div className="bus-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=500&q=80"
                  alt="Goa beaches"
                  loading="lazy"
                />
                <div className="bus-img-overlay" />
                <div className="bus-img-label">Pune → Goa</div>
              </div>
              <div className="bus-body">
                <div className="bus-meta">9h · Sleeper · 18 operators</div>
                <div className="bus-price">from ₹899</div>
                <span className="bus-badge">
                  <i className="ti ti-clock" aria-hidden="true" /> 9 hrs
                </span>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* ═══ VISA + ESIM ═══ */}
      <section className="section" id="visa">
        <div className="container">
          <div className="section-header">
            <div>
              <span className="section-label">Unique to Fastays</span>
              <h2 className="section-title">
                Visa &amp; <span>eSIM Services</span>
              </h2>
            </div>
          </div>
          <div className="addon-grid">
            <div
              className="addon-card visa-card"
              id="esim"
              style={{ padding: '0px' }}
            >
              <div style={{ position: 'relative' }}>
                <img
                  className="addon-img-banner"
                  src="https://images.unsplash.com/photo-1503220317375-aaad61436b1b?w=800&q=80"
                  alt="Visa travel passport"
                  loading="lazy"
                />
                <div className="addon-img-overlay" />
                <div
                  style={{
                    position: 'absolute',
                    top: '20px',
                    left: '24px',
                    zIndex: 1,
                  }}
                >
                  <div className="addon-tag">
                    <i className="ti ti-world" aria-hidden="true" /> 150+
                    Countries
                  </div>
                  <div
                    style={{ fontSize: '22px', fontWeight: 800, color: '#fff' }}
                  >
                    Visa Assistance
                  </div>
                </div>
              </div>
              <div className="addon-body">
                <p className="addon-sub">
                  Expert processing for tourist, business &amp; transit visas.
                  Track your application status in real time.
                </p>
                <ul className="addon-features">
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" aria-hidden="true" />
                    </span>{' '}
                    Document checklist &amp; expert guidance
                  </li>
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" aria-hidden="true" />
                    </span>{' '}
                    Real-time application tracking
                  </li>
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" aria-hidden="true" />
                    </span>{' '}
                    150+ countries covered
                  </li>
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" aria-hidden="true" />
                    </span>{' '}
                    Dedicated visa support team
                  </li>
                </ul>
              </div>
            </div>
            <div className="addon-card esim-card" id="esim">
              <div style={{ position: 'relative' }}>
                <img
                  className="addon-img-banner"
                  src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80"
                  alt="eSIM mobile travel connectivity"
                  loading="lazy"
                />
                <div className="addon-img-overlay" />
                <div
                  style={{
                    position: 'absolute',
                    top: '20px',
                    left: '24px',
                    zIndex: 1,
                  }}
                >
                  <div className="addon-tag">
                    <i className="ti ti-sim-card" aria-hidden="true" /> 190+
                    Countries
                  </div>
                  <div
                    style={{ fontSize: '22px', fontWeight: 800, color: '#fff' }}
                  >
                    eSIM for Travellers
                  </div>
                </div>
              </div>
              <div className="addon-body">
                <p className="addon-sub">
                  Stay connected everywhere with instant eSIM activation. No
                  physical SIM needed. No roaming bills.
                </p>
                <ul className="addon-features">
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" aria-hidden="true" />
                    </span>{' '}
                    Instant digital activation
                  </li>
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" aria-hidden="true" />
                    </span>{' '}
                    190+ countries &amp; regions
                  </li>
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" aria-hidden="true" />
                    </span>{' '}
                    Data plans from ₹199
                  </li>
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" aria-hidden="true" />
                    </span>{' '}
                    No roaming or hidden charges
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ USP / STATS ═══ */}
      <section className="usp-section" id="why-us">
        <div className="container">
          <div
            style={{
              borderRadius: '20px',
              overflow: 'hidden',
              position: 'relative',
              marginBottom: '40px',
              height: '200px',
            }}
          >
            <img
              src="https://images.unsplash.com/photo-1556761175-4b46a572b786?w=1400&q=75"
              alt="Fastays agent team"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block',
              }}
            />
            <div
              style={{
                position: 'absolute',
                inset: 0,
                background:
                  'linear-gradient(to right,rgba(10,20,50,.92) 0%,rgba(10,20,50,.55) 60%,rgba(10,20,50,.25) 100%)',
              }}
            />
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '36px',
                transform: 'translateY(-50%)',
              }}
            >
              <div
                style={{
                  fontSize: '11px',
                  fontWeight: 700,
                  color: 'rgba(255,255,255,.5)',
                  textTransform: 'uppercase',
                  letterSpacing: '.7px',
                  marginBottom: '6px',
                }}
              >
                Trusted by 600+ travel professionals
              </div>
              <div
                style={{
                  fontSize: '26px',
                  fontWeight: 800,
                  color: '#fff',
                  lineHeight: 1.2,
                }}
              >
                The numbers behind
              </div>
              <div
                style={{
                  fontSize: '26px',
                  fontWeight: 800,
                  color: 'var(--brand)',
                  lineHeight: 1.2,
                }}
              >
                Powering Agent Growth Across India
              </div>
            </div>
          </div>
          <div className="usp-heading">
            <span className="section-label">Why agents choose us</span>
            <h2 className="section-title">
              Trusted by <span>600+ Travel Agents</span>
            </h2>
            <p className="usp-sub">
              The Numbers Behind India&apos;s most-loved B2B travel platform
            </p>
          </div>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-num">10L+</div>
              <div className="stat-label">Commission paid out monthly</div>
              <div className="stat-desc">On-time payouts, zero delays</div>
            </div>
            <div className="stat-card">
              <div className="stat-num">600+</div>
              <div className="stat-label">Active agents nationwide</div>
              <div className="stat-desc">
                Growing community of travel professionals
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-num">100K+</div>
              <div className="stat-label">Bookings processed</div>
              <div className="stat-desc">
                Flights, hotels, buses, visa &amp; eSIM
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-num">190+</div>
              <div className="stat-label">Countries covered</div>
              <div className="stat-desc">
                International flights, visa &amp; eSIM
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-num">24/7</div>
              <div className="stat-label">Dedicated agent support</div>
              <div className="stat-desc">
                Helpline, chat &amp; WhatsApp always on
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-num">4.8★</div>
              <div className="stat-label">Agent satisfaction score</div>
              <div className="stat-desc">Highest-rated B2B travel platform</div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ TRIP PROTECTION ═══ */}
      <section className="section" id="insurance">
        <div className="container">
          <div className="section-header">
            <div>
              <span className="section-label">Complete peace of mind</span>
              <h2 className="section-title">
                Trip <span>Protection Plans</span>
              </h2>
              <p
                style={{
                  fontSize: '13px',
                  color: 'var(--muted)',
                  marginTop: '6px',
                  maxWidth: '560px',
                }}
              >
                Covers domestic &amp; international — flights, hotel stays, and
                complete trip costs. One plan, total protection.
              </p>
            </div>
          </div>

          <div className="ins-grid">
            <article className="ins-card">
              <div className="ins-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1488085061387-422e29b40080?w=500&q=80"
                  alt="Domestic flight hotel protection"
                  loading="lazy"
                />
                <div className="ins-img-overlay" />
                <div className="ins-img-label">Domestic Shield</div>
              </div>
              <div className="ins-body">
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '6px',
                  }}
                >
                  <div className="ins-name">Domestic Shield</div>
                  <span
                    style={{
                      fontSize: '9px',
                      fontWeight: 700,
                      background: '#ECFDF5',
                      color: '#059669',
                      padding: '2px 6px',
                      borderRadius: '4px',
                    }}
                  >
                    FLIGHT + HOTEL
                  </span>
                </div>
                <div className="ins-desc">
                  Flight delay, hotel no-show, trip cancellation &amp; medical
                  cover for all domestic travel.
                </div>
                <span className="ins-price">From ₹49 / trip</span>
              </div>
            </article>

            <article className="ins-card">
              <div className="ins-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=500&q=80"
                  alt="International flight hotel protection"
                  loading="lazy"
                />
                <div className="ins-img-overlay" />
                <div className="ins-img-label">International Guard</div>
              </div>
              <div className="ins-body">
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '6px',
                  }}
                >
                  <div className="ins-name">International Guard</div>
                  <span
                    style={{
                      fontSize: '9px',
                      fontWeight: 700,
                      background: '#EEF2FF',
                      color: '#4F46E5',
                      padding: '2px 6px',
                      borderRadius: '4px',
                    }}
                  >
                    FLIGHT + HOTEL
                  </span>
                </div>
                <div className="ins-desc">
                  Full medical, evacuation, hotel &amp; flight cover for all
                  international trips.
                </div>
                <span className="ins-price">From ₹89 / day</span>
              </div>
            </article>

            <article className="ins-card">
              <div className="ins-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=500&q=80"
                  alt="Complete trip protection"
                  loading="lazy"
                />
                <div className="ins-img-overlay" />
                <div className="ins-img-label">Total Trip Cover</div>
              </div>
              <div className="ins-body">
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '6px',
                  }}
                >
                  <div className="ins-name">Total Trip Cover</div>
                  <span
                    style={{
                      fontSize: '9px',
                      fontWeight: 700,
                      background: 'var(--brand-light)',
                      color: 'var(--brand-dark)',
                      padding: '2px 6px',
                      borderRadius: '4px',
                    }}
                  >
                    MOST POPULAR
                  </span>
                </div>
                <div className="ins-desc">
                  Covers domestic + international flights &amp; hotels in one
                  comprehensive plan.
                </div>
                <span className="ins-price">From ₹149 / trip</span>
              </div>
            </article>

            <article className="ins-card">
              <div className="ins-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=500&q=80"
                  alt="Corporate group trip protection"
                  loading="lazy"
                />
                <div className="ins-img-overlay" />
                <div className="ins-img-label">Corporate Plan</div>
              </div>
              <div className="ins-body">
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '6px',
                  }}
                >
                  <div className="ins-name">Corporate Plan</div>
                  <span
                    style={{
                      fontSize: '9px',
                      fontWeight: 700,
                      background: '#F5F3FF',
                      color: '#7C3AED',
                      padding: '2px 6px',
                      borderRadius: '4px',
                    }}
                  >
                    GROUP
                  </span>
                </div>
                <div className="ins-desc">
                  Multi-trip annual cover for corporate groups. Dom. &amp; intl.
                  flights and hotels included.
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '4px',
                    margin: '8px 0',
                  }}
                >
                  <span
                    style={{
                      fontSize: '10px',
                      color: '#059669',
                      background: '#ECFDF5',
                      padding: '2px 7px',
                      borderRadius: '4px',
                    }}
                  >
                    ✓ Dom + Intl
                  </span>
                  <span
                    style={{
                      fontSize: '10px',
                      color: '#4F46E5',
                      background: '#EEF2FF',
                      padding: '2px 7px',
                      borderRadius: '4px',
                    }}
                  >
                    ✓ Group Cover
                  </span>
                  <span
                    style={{
                      fontSize: '10px',
                      color: '#7C3AED',
                      background: '#F5F3FF',
                      padding: '2px 7px',
                      borderRadius: '4px',
                    }}
                  >
                    ✓ Annual Plan
                  </span>
                </div>
                <span className="ins-price">Custom pricing</span>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* ═══ TESTIMONIALS ═══ */}
      <section className="section section-alt" id="testimonials">
        <div className="container">
          <div className="section-header section-header-center">
            <div>
              <span className="section-label">Testimonials</span>
              <h2 className="section-title">
                What Our <span>Travelers Say</span>
              </h2>
              <p
                style={{
                  fontSize: '13px',
                  color: 'var(--muted)',
                  marginTop: '6px',
                }}
              >
                Real experiences from our happy travelers
              </p>
            </div>
          </div>
          <div className="testi-track">
            <article className="testi-card">
              <div className="t-name">Prashant Dhongade</div>
              <div className="t-stars">★★★★★</div>
              <p className="t-quote">
                Honestly wasn&apos;t expecting much but the app just works.
                Opens fast, doesn&apos;t hang, and I can get to what I need
                without hunting around.
              </p>
              <div className="t-city">- Aurangabad</div>
            </article>
            <article className="testi-card">
              <div className="t-name">Jasleen Bhatia</div>
              <div className="t-stars">★★★★☆</div>
              <p className="t-quote">
                I&apos;ve used a couple of trading apps before and they always
                felt like too much was going on. This one is refreshingly clean.
              </p>
              <div className="t-city">- Ludhiana</div>
            </article>
            <article className="testi-card">
              <div className="t-name">T. Venkataramaiah</div>
              <div className="t-stars">★★★★★</div>
              <p className="t-quote">
                My old app used to lag during market hours. This one hasn&apos;t
                given me that problem even once. That alone makes a big
                difference.
              </p>
              <div className="t-city">- Guntur</div>
            </article>
            <article className="testi-card">
              <div className="t-name">Rajesh Kumar</div>
              <div className="t-stars">★★★★★</div>
              <p className="t-quote">
                Fastays has completely changed how I run my travel business.
                Commission is the best in market and payouts are always on time.
              </p>
              <div className="t-city">- New Delhi</div>
            </article>
            <article className="testi-card">
              <div className="t-name">Priya Sharma</div>
              <div className="t-stars">★★★★★</div>
              <p className="t-quote">
                The visa and eSIM services are a huge differentiator. My clients
                get a complete one-stop experience and my bookings have grown
                40% this year.
              </p>
              <div className="t-city">- Mumbai</div>
            </article>
            <article className="testi-card">
              <div className="t-name">Anand Verma</div>
              <div className="t-stars">★★★★★</div>
              <p className="t-quote">
                Dashboard is clean, bookings are fast, and the support team
                actually picks up the phone. Been using Fastays for 2 years and
                couldn&apos;t be happier!
              </p>
              <div className="t-city">- Pune</div>
            </article>
          </div>
        </div>
      </section>

      {/* ═══ WHY WORK WITH US ═══ */}
      <section className="section" id="why-us">
        <div className="container">
          <div className="section-header">
            <div>
              <span className="section-label">Your growth partner</span>
              <h2 className="section-title">
                Why <span>Work With Us?</span>
              </h2>
              <p
                style={{
                  fontSize: '13px',
                  color: 'var(--muted)',
                  marginTop: '6px',
                }}
              >
                Everything you need to run a successful travel business — under
                one roof
              </p>
            </div>
          </div>

          <div className="why-banner">
            <img
              src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=1200&q=80"
              alt="Team working together travel business"
            />
            <div className="why-banner-overlay" />
            <div className="why-banner-content">
              <h3>Join 600+ agents already growing with Fastays</h3>
              <p>
                India&apos;s only B2B platform with Flights, Stays, Buses, Trip
                Protection, Visa &amp; eSIM — all with agent commissions
              </p>
              <button type="button" onClick={handleSignUpClick}>
                Register as Agent <i className="ti ti-arrow-right" />
              </button>
            </div>
          </div>

          <div className="why-grid">
            <div className="why-card">
              <div className="why-card-img">
                <img
                  src="https://images.unsplash.com/photo-1553729459-efe14ef6055d?w=500&q=80"
                  alt="Best commissions"
                />
              </div>
              <div className="why-card-body">
                <div className="why-card-title">Best Commissions</div>
                <div className="why-card-num" style={{ color: 'var(--brand)' }}>
                  Up to 8%
                </div>
                <div className="why-card-sub">commission per booking</div>
              </div>
            </div>
            <div className="why-card">
              <div className="why-card-img">
                <img
                  src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=500&q=80"
                  alt="Smart dashboard"
                />
              </div>
              <div className="why-card-body">
                <div className="why-card-title">Smart Dashboard</div>
                <div className="why-card-num" style={{ color: '#4F46E5' }}>
                  360°
                </div>
                <div className="why-card-sub">business visibility</div>
              </div>
            </div>
            <div className="why-card">
              <div className="why-card-img">
                <img
                  src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=500&q=80"
                  alt="24/7 support"
                />
              </div>
              <div className="why-card-body">
                <div className="why-card-title">24/7 Agent Support</div>
                <div className="why-card-num" style={{ color: '#059669' }}>
                  &lt;2 min
                </div>
                <div className="why-card-sub">average response time</div>
              </div>
            </div>
            <div className="why-card">
              <div className="why-card-img">
                <img
                  src="https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=500&q=80"
                  alt="Instant booking"
                />
              </div>
              <div className="why-card-body">
                <div className="why-card-title">Instant Booking</div>
                <div className="why-card-num" style={{ color: '#DC2626' }}>
                  5 sec
                </div>
                <div className="why-card-sub">ticket generation</div>
              </div>
            </div>
            <div className="why-card">
              <div className="why-card-img">
                <img
                  src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=500&q=80"
                  alt="Payment options"
                />
              </div>
              <div className="why-card-body">
                <div className="why-card-title">Flexible Payments</div>
                <div className="why-card-num" style={{ color: '#7C3AED' }}>
                  10+
                </div>
                <div className="why-card-sub">payment methods accepted</div>
              </div>
            </div>
            <div className="why-card">
              <div className="why-card-img">
                <img
                  src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=500&q=80"
                  alt="Agent training"
                />
              </div>
              <div className="why-card-body">
                <div className="why-card-title">Training &amp; Onboarding</div>
                <div className="why-card-num" style={{ color: '#EA580C' }}>
                  Free
                </div>
                <div className="why-card-sub">training &amp; onboarding</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ NEWS & ANNOUNCEMENTS ═══ */}
      <section className="section" id="news">
        <div className="container">
          <div className="section-header">
            <div>
              <span className="section-label">Stay in the loop</span>
              <h2 className="section-title">
                News &amp; <span>Announcements</span>
              </h2>
              <p
                style={{
                  fontSize: '13px',
                  color: 'var(--muted)',
                  marginTop: '6px',
                }}
              >
                Latest updates, new features and important announcements for
                Fastays agents
              </p>
            </div>
          </div>
          <div className="news-grid">
            <article className="news-featured">
              <div className="news-featured-img">
                <img
                  src="https://images.unsplash.com/photo-1556742393-d75f468bfcb0?w=800&q=80"
                  alt="Fastays platform launch announcement"
                />
                <span className="news-tag-badge">🔥 FEATURED</span>
              </div>
              <div className="news-featured-body">
                <div className="news-meta">
                  <i className="ti ti-calendar" /> June 5, 2025 &nbsp;·&nbsp;{' '}
                  <i className="ti ti-tag" /> Product Update
                </div>
                <div className="news-title">
                  Fastays launches New Agent Dashboard 3.0 with real-time
                  earnings tracker
                </div>
                <div className="news-desc">
                  Our biggest platform upgrade yet — new UI, faster search,
                  commission analytics, and bulk booking support are all live
                  for agents today.
                </div>
                <a
                  href="/news/dashboard-3"
                  className="news-link"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/news/dashboard-3');
                  }}
                >
                  Read more <i className="ti ti-arrow-right" />
                </a>
              </div>
            </article>
            <div className="news-side">
              <article className="news-side-card">
                <div className="news-side-img">
                  <img
                    src="https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=600&q=80"
                    alt="Agent partner programme"
                  />
                  <span
                    className="news-side-tag"
                    style={{ background: '#4F46E5' }}
                  >
                    PARTNERSHIP
                  </span>
                </div>
                <div className="news-side-body">
                  <div className="news-meta" style={{ marginBottom: '4px' }}>
                    <i className="ti ti-calendar" /> May 28, 2025
                  </div>
                  <div
                    style={{
                      fontSize: '13px',
                      fontWeight: 700,
                      color: 'var(--text)',
                      marginBottom: '4px',
                      lineHeight: 1.35,
                    }}
                  >
                    Fastays signs MOU with 3 major airline groups for exclusive
                    agent fares
                  </div>
                  <a
                    href="/news/airline-mou"
                    className="news-link"
                    style={{ fontSize: '11.5px' }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/news/airline-mou');
                    }}
                  >
                    Read more <i className="ti ti-arrow-right" />
                  </a>
                </div>
              </article>
              <article className="news-side-card">
                <div className="news-side-img">
                  <img
                    src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&q=80"
                    alt="International expansion"
                  />
                  <span
                    className="news-side-tag"
                    style={{ background: '#059669' }}
                  >
                    EXPANSION
                  </span>
                </div>
                <div className="news-side-body">
                  <div className="news-meta" style={{ marginBottom: '4px' }}>
                    <i className="ti ti-calendar" /> May 15, 2025
                  </div>
                  <div
                    style={{
                      fontSize: '13px',
                      fontWeight: 700,
                      color: 'var(--text)',
                      marginBottom: '4px',
                      lineHeight: 1.35,
                    }}
                  >
                    Fastays expands eSIM coverage to 190+ countries with new
                    global partner
                  </div>
                  <a
                    href="/news/esim-expansion"
                    className="news-link"
                    style={{ fontSize: '11.5px' }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/news/esim-expansion');
                    }}
                  >
                    Read more <i className="ti ti-arrow-right" />
                  </a>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ WHY CHOOSE US — 5 REASONS ═══ */}
      <section className="section section-alt" id="five-reasons">
        <div className="container">
          <div className="section-header section-header-center">
            <div>
              <span className="section-label">Why choose us?</span>
              <h2 className="section-title">
                5 Reasons To Start Your <span>Business With Us</span>
              </h2>
              <p
                style={{
                  fontSize: '13px',
                  color: 'var(--muted)',
                  marginTop: '8px',
                  maxWidth: '560px',
                }}
              >
                Everything a travel agent needs to launch, run and grow a
                profitable business — built into one platform
              </p>
            </div>
          </div>

          <div className="d-flex flex-column" style={{ gap: 0 }}>
            <div className="reason-row">
              <div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginBottom: '12px',
                  }}
                >
                  <span
                    style={{
                      fontSize: '11px',
                      fontWeight: 700,
                      color: '#4F46E5',
                      textTransform: 'uppercase',
                      letterSpacing: '.6px',
                    }}
                  >
                    Reason 1 · Flights
                  </span>
                </div>
                <div
                  style={{
                    fontSize: '20px',
                    fontWeight: 800,
                    color: 'var(--text)',
                    marginBottom: '10px',
                  }}
                >
                  Wide Flight Options, Best Fares
                </div>
                <p
                  style={{
                    fontSize: '13px',
                    color: 'var(--muted)',
                    lineHeight: 1.7,
                    marginBottom: '14px',
                  }}
                >
                  Find the best flight deals with multiple fare options and
                  transparent policies. Choose from 500+ airlines and domestic
                  &amp; international routes, all at agent-exclusive prices.
                </p>
                <ul className="reason-list">
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" />
                    </span>{' '}
                    Compare fares across 500+ airlines instantly
                  </li>
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" />
                    </span>{' '}
                    Clear, transparent booking policies
                  </li>
                </ul>
              </div>
              <div className="reason-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=700&q=80"
                  alt="Flight booking options"
                />
              </div>
            </div>

            <div className="reason-row">
              <div style={{ order: 2 }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginBottom: '12px',
                  }}
                >
                  <span
                    style={{
                      fontSize: '11px',
                      fontWeight: 700,
                      color: '#059669',
                      textTransform: 'uppercase',
                      letterSpacing: '.6px',
                    }}
                  >
                    Reason 2 · Hotels
                  </span>
                </div>
                <div
                  style={{
                    fontSize: '20px',
                    fontWeight: 800,
                    color: 'var(--text)',
                    marginBottom: '10px',
                  }}
                >
                  Explore Worldwide Hotel Inventory
                </div>
                <p
                  style={{
                    fontSize: '13px',
                    color: 'var(--muted)',
                    lineHeight: 1.7,
                    marginBottom: '14px',
                  }}
                >
                  Access a wide range of hotels across India and abroad. From
                  budget stays to 5-star resorts, give your clients more choices
                  and better margins on every booking.
                </p>
                <ul className="reason-list">
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" />
                    </span>{' '}
                    1M+ hotels across 190+ countries
                  </li>
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" />
                    </span>{' '}
                    Instant vouchers &amp; flexible cancellation
                  </li>
                </ul>
              </div>
              <div className="reason-img-wrap" style={{ order: 1 }}>
                <img
                  src="https://images.unsplash.com/photo-1566073771259-6a8506099945?w=700&q=80"
                  alt="Hotel booking inventory"
                />
              </div>
            </div>

            <div className="reason-row">
              <div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginBottom: '12px',
                  }}
                >
                  <span
                    style={{
                      fontSize: '11px',
                      fontWeight: 700,
                      color: 'var(--brand-dark)',
                      textTransform: 'uppercase',
                      letterSpacing: '.6px',
                    }}
                  >
                    Reason 3 · Earnings
                  </span>
                </div>
                <div
                  style={{
                    fontSize: '20px',
                    fontWeight: 800,
                    color: 'var(--text)',
                    marginBottom: '10px',
                  }}
                >
                  Best Commission Rates in the Industry
                </div>
                <p
                  style={{
                    fontSize: '13px',
                    color: 'var(--muted)',
                    lineHeight: 1.7,
                    marginBottom: '14px',
                  }}
                >
                  Earn more on every flight, hotel, bus, and trip protection
                  sale. Commissions are credited automatically with zero delays
                  — no chasing payments, ever.
                </p>
                <ul className="reason-list">
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" />
                    </span>{' '}
                    Up to 8% commission per booking
                  </li>
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" />
                    </span>{' '}
                    Weekly automated payouts
                  </li>
                </ul>
              </div>
              <div className="reason-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=700&q=80"
                  alt="Agent commission earnings"
                />
              </div>
            </div>

            <div className="reason-row">
              <div style={{ order: 2 }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginBottom: '12px',
                  }}
                >
                  <span
                    style={{
                      fontSize: '11px',
                      fontWeight: 700,
                      color: '#7C3AED',
                      textTransform: 'uppercase',
                      letterSpacing: '.6px',
                    }}
                  >
                    Reason 4 · Tech
                  </span>
                </div>
                <div
                  style={{
                    fontSize: '20px',
                    fontWeight: 800,
                    color: 'var(--text)',
                    marginBottom: '10px',
                  }}
                >
                  Interactive Web &amp; Mobile Agent Portal
                </div>
                <p
                  style={{
                    fontSize: '13px',
                    color: 'var(--muted)',
                    lineHeight: 1.7,
                    marginBottom: '14px',
                  }}
                >
                  Run your entire business from your laptop or phone. Real-time
                  analytics, booking history, and client management — all in one
                  clean, fast dashboard.
                </p>
                <ul className="reason-list">
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" />
                    </span>{' '}
                    Mobile-friendly dashboard works anywhere
                  </li>
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" />
                    </span>{' '}
                    Live booking tracking &amp; earnings dashboard
                  </li>
                </ul>
              </div>
              <div className="reason-img-wrap" style={{ order: 1 }}>
                <img
                  src="https://images.unsplash.com/photo-1531403009284-440f080d1e12?w=700&q=80"
                  alt="Agent portal software UI"
                />
              </div>
            </div>

            <div className="reason-row">
              <div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginBottom: '12px',
                  }}
                >
                  <span
                    style={{
                      fontSize: '11px',
                      fontWeight: 700,
                      color: '#D97706',
                      textTransform: 'uppercase',
                      letterSpacing: '.6px',
                    }}
                  >
                    Reason 5 · Support
                  </span>
                </div>
                <div
                  style={{
                    fontSize: '20px',
                    fontWeight: 800,
                    color: 'var(--text)',
                    marginBottom: '10px',
                  }}
                >
                  24/7 Dedicated Agent Support
                </div>
                <p
                  style={{
                    fontSize: '13px',
                    color: 'var(--muted)',
                    lineHeight: 1.7,
                    marginBottom: '14px',
                  }}
                >
                  A real support team that picks up the phone. Get help with
                  bookings, amendments, and cancellations any time of day, every
                  day of the year.
                </p>
                <ul className="reason-list">
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" />
                    </span>{' '}
                    Phone, chat &amp; WhatsApp support
                  </li>
                  <li>
                    <span className="check-icon-span">
                      <i className="ti ti-check" />
                    </span>{' '}
                    &lt;2 min average response time
                  </li>
                </ul>
              </div>
              <div className="reason-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=700&q=80"
                  alt="Agent customer service support"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ OUR PARTNERS ═══ */}
      <section className="section" id="awards">
        <div className="container">
          <div className="section-header section-header-center">
            <div>
              <span className="section-label">Trusted by the best</span>
              <h2 className="section-title">
                Our <span>Partners &amp; Accreditations</span>
              </h2>
              <p
                style={{
                  fontSize: '13px',
                  color: 'var(--muted)',
                  marginTop: '8px',
                  maxWidth: '560px',
                }}
              >
                Fastays is officially recognised, accredited and partnered with
                India&apos;s most trusted travel and tourism bodies
              </p>
            </div>
          </div>

          <div className="partners-banner">
            <img
              src="https://images.unsplash.com/photo-1521727857535-28d2047618ad?w=1400&q=75"
              alt="Airplane wing at sunset"
            />
            <div className="partners-banner-overlay" />
            <div className="partners-banner-content">
              <div
                style={{
                  fontSize: '22px',
                  fontWeight: 800,
                  color: '#fff',
                  marginBottom: '8px',
                }}
              >
                Accredited. Certified. Trusted.
              </div>
              <div
                style={{
                  fontSize: '13px',
                  color: 'rgba(255,255,255,.7)',
                  lineHeight: 1.6,
                }}
              >
                Fastays holds official accreditations from IATA, Government of
                India, ISO, TIA &amp; Startup India — giving agents and clients
                total confidence.
              </div>
            </div>
          </div>

          <div className="partners-divider-wrap">
            <div className="partners-divider" />
          </div>

          <div className="partners-grid">
            <div className="partner-logo-item">
              <img
                src="/images/fastays/iata.png"
                alt="IATA"
                style={{
                  maxHeight: '60px',
                  maxWidth: '100%',
                  objectFit: 'contain',
                }}
              />
            </div>

            <div className="partner-logo-item">
              <img
                src="/images/fastays/tia.png"
                alt="TIA"
                style={{
                  maxHeight: '60px',
                  maxWidth: '100%',
                  objectFit: 'contain',
                }}
              />
            </div>

            <div className="partner-logo-item">
              <img
                src="/images/fastays/incIndia.png"
                alt="Incredible India"
                style={{
                  maxHeight: '60px',
                  maxWidth: '100%',
                  objectFit: 'contain',
                }}
              />
            </div>

            <div className="partner-logo-item">
              <img
                src="/images/fastays/iso.png"
                alt="ISO"
                style={{
                  maxHeight: '60px',
                  maxWidth: '100%',
                  objectFit: 'contain',
                }}
              />
            </div>

            <div className="partner-logo-item">
              <img
                src="/images/fastays/nidhi.png"
                alt="Nidhi / Startup India"
                style={{
                  maxHeight: '60px',
                  maxWidth: '100%',
                  objectFit: 'contain',
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* ═══ APP DOWNLOAD ═══ */}
      <section className="app-section">
        <div className="container">
          <div className="app-inner">
            <div>
              <div className="app-label">FASTAYS AGENT APP</div>
              <h2 className="app-title"> Manage All Bookings On The Go</h2>
              <p className="app-sub">
                Download the Fastays Agent App and handle your entire travel
                business from your phone. Search, book, track, and manage all
                client trips anytime, anywhere.
              </p>
              <div className="app-btns">
                <a
                  href="https://play.google.com/store/apps/details?id=com.fastaysb2b"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="app-store-btn text-decoration-none"
                >
                  <i className="ti ti-brand-google-play" aria-hidden="true" />
                  <div className="app-store-text">
                    <span className="app-store-label">Get it on</span>
                    <span className="app-store-name">Google Play</span>
                  </div>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.fastaysb2b"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="app-store-btn text-decoration-none"
                >
                  <i className="ti ti-brand-apple" aria-hidden="true" />
                  <div className="app-store-text">
                    <span className="app-store-label">Download on the</span>
                    <span className="app-store-name">App Store</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="app-img-wrap">
              <img
                src="/images/fastays/fastays_app_preview.png"
                alt="Fastays Agent App Login Preview"
              />
            </div>
          </div>
        </div>
      </section>

      {/* OTP verification modal */}
      {showOtpModal && (
        <AppModal
          modalTitle="Enter OTP Received on Email"
          showCloseButton
          onModalClose={() => setShowOtpModal(false)}
        >
          <div className="d-flex gap-2 p-3">
            <AppTextInput
              onChange={handleChange}
              value={login.otp || ''}
              name="otp"
              placeholderText=""
              label="OTP"
            />
            <AppButton btnText="Done" onClick={handleLoginSubmit} />
          </div>
        </AppModal>
      )}
    </div>
  );
}
